<!-- Header -->
<header class=" container-fluid header landingpage">

    <div class=" container header-bottom-area">
        <div>
            <div class="row align-items-center">
                <div class="col-lg-3 col-md-6 col-6">
                    <div class="cuscol">
                        <div class="logo">
                            <a href="index.html">
                                <img class="bluelogo" src="assets/images/logo/cropped-logo-2.png" alt="logo">
                                <img class="whitelogo" src="assets/images/logo/whitelogo.png" alt="logo">
                            </a>
                        </div>
                    </div>
                </div>

                <div class="col-lg-9 d-none d-lg-block">
                    <div class="menu-area d-flex align-items-center justify-content-end">
                        <nav class="main-menu text-center">
                            <ul>
                                <li class="has-dropdown"><a class="lst" style="color: #163e6f;">Product for Corporates</a>
                                    <ul class="sub-menu">
                                        <li><a routerLink="/appprotectt">AppProtectt</a></li>
                                        <li><a routerLink="/appprotectt-lite">AppProtectt Lite</a></li>
                                        <li><a routerLink="/appbind">AppBind</a></li>
                                        <li><a routerLink="/mprotectt-biz-plus">MProtectt Biz+</a></li>
                                        <li><a routerLink="/realtime-protectt">RealTime Protectt</a></li>
                                        <li><a routerLink="/platform">Platform</a></li>
                                    </ul>
                                </li>
                                <li class="has-dropdown"><a class="lst" style="color: #163e6f;">Product for Individuals</a>
                                    <ul class="sub-menu">
                                        <li><a routerLink="/mprotectt">About Mobile Security</a></li>
                                        <li><a routerLink="mprotectt/android">Android</a></li>
                                        <li><a style="text-transform: none;" routerLink="mprotectt/ios">iOS</a></li>
                                        <!-- <li><a href="#">Customer Portal</a></li> -->
                                    </ul>
                                </li>
                                <li class="has-dropdown"><a class="lst" style="color: #163e6f;">Cyber Security Solution</a>
                                    <ul class="sub-menu" style="width: 300px">
                                        <li><a routerLink="/rasp">Runtime Application Self Protection</a></li>
                                        <li><a routerLink="/mobile-device-security">Mobile Device Security</a></li>
                                        <li><a routerLink="/rbi-digital-payment-security-control-solution">Digital
                                            Payment Security Control</a>
                                        </li>
                                        <li><a routerLink="/frm">Fraud & Risk Management</a></li>
                                        <li><a routerLink="/byod">Bring your own device</a></li>
                                        <!-- <li><a href="#">Mobile Threat intelligence</a></li> -->
                                        <li><a routerLink="/cyber-lab-services">Cyber Lab Services</a></li>
                                    </ul>
                                </li>
                                <li class="has-dropdown"><a class="lst" style="color: #163e6f;">Resources</a>
                                    <ul class="sub-menu">
                                        <li><a routerLink="/blogs">Blogs</a></li>
                                        <!-- <li><a href="#">Analytical Reports</a></li> -->
                                        <!-- <li><a href="#">Engineering Resources</a></li> -->
                                        <li><a routerLink="/industry-news">Industry News</a></li>
                                        <!-- <li><a href="#">Webinars</a></li> -->
                                        <!-- <li><a routerLink="/case-studies">Case Studies</a></li> -->
                                        <li><a routerLink="/community">Community</a></li>
                                        <li><a routerLink="/ebrochure">E-Brochure</a></li>
                                    </ul>
                                </li>
                                <li class="has-dropdown"><a class="lst" style="color: #163e6f;">Company</a>
                                    <ul class="sub-menu">
                                        <li><a routerLink="/about-us">About Us</a></li>
                                        <li><a routerLink="/leadership-team">Leadership Team</a></li>
                                        <li><a routerLink="/customers">Customers</a></li>
                                        <li><a routerLink="/partners">Partners</a></li>
                                        <li><a routerLink="/media">Media</a></li>
                                        <!-- <li><a href="#">Media center</a></li> -->
                                        <!-- <li><a routerLink="/leadership-team">Leadership Team</a></li> -->
                                        <li><a routerLink="/careers">Careers</a></li>
                                        <!-- <li><a routerLink="/life-at-protectt-ai">Life at Protectt.ai</a></li> -->
                                    </ul>
                                </li>
                            </ul>
                        </nav>
                        <!--// main-menu -->
                        <!-- <div class="header-btn text-right">
                  <a class="btn-circle btn-transparent btn" href="#">appointment</a>
              </div> -->
                    </div>
                </div>

                <!-- Show in small device Start -->
                <div class="clickable-menu clickable-mainmenu-active d-block d-lg-none col-md-6 col-6">
                    <a class="coloredmenu" href="#"><i class="zmdi zmdi-menu"></i></a>
                    <a class="whitemenu" href="#"><i class="zmdi zmdi-menu"></i></a>
                </div>
                <div class="clickable-mainmenu">
                    <div class="clickable-mainmenu-icon">
                        <button class="clickable-mainmenu-close">
                            <span class="zmdi zmdi-close"></span>
                        </button>
                    </div>

                    <div id="menu" class="text-left clickable-menu-style">
                        <ul>
                            <li><a routerLink="/" (click)="toToggleClass()">Home</a></li>
                            <li>
                                <a href="">Product for Corporates</a>
                                <ul>
                                    <li><a routerLink="/appprotectt" (click)="toToggleClass()">AppProtectt</a></li>
                                    <li><a routerLink="/appprotectt-lite" (click)="toToggleClass()">AppProtectt Lite</a>
                                    </li>
                                    <li><a routerLink="/appbind" (click)="toToggleClass()">AppBind</a></li>
                                    <li><a routerLink="/mprotectt-biz-plus" (click)="toToggleClass()">MProtectt Biz+</a></li>
                                    <li><a routerLink="/realtime-protectt" (click)="toToggleClass()">RealTime Protectt</a></li>
                                    <li><a routerLink="/platform" (click)="toToggleClass()">Platform</a></li>
                                </ul>

                                <li>
                                    <a href="">Product for Individuals</a>
                                    <ul>
                                        <li><a routerLink="/mprotectt" (click)="toToggleClass()">About Mobile Security</a>
                                        </li>
                                        <li><a routerLink="mprotectt/android" (click)="toToggleClass()">Android</a></li>
                                        <li><a style="text-transform: none;" routerLink="mprotectt/ios" (click)="toToggleClass()">iOS</a></li>
                                        <!-- <li><a href="#">Customer Portal</a></li> -->
                                    </ul>
                                </li>
                                <li><a href="">Cyber Security Solution</a>
                                    <ul>
                                        <li><a routerLink="/rasp" (click)="toToggleClass()">Runtime Application Self Protection</a></li>
                                        <li><a routerLink="/mobile-device-security" (click)="toToggleClass()">Mobile Device Security</a></li>
                                        <li><a routerLink="/rbi-digital-payment-security-control-solution" (click)="toToggleClass()">Digital Payment Security Control</a></li>
                                        <li><a routerLink="/frm" (click)="toToggleClass()">Fraud & Risk Management</a></li>
                                        <li><a routerLink="/byod" (click)="toToggleClass()">Bring your own device</a></li>
                                        <li><a routerLink="/cyber-lab-services" (click)="toToggleClass()">Cyber Lab Services</a></li>
                                    </ul>
                                </li>
                                <li><a href="">Resources</a>
                                    <ul>
                                        <li><a routerLink="/blogs" (click)="toToggleClass()">Blogs</a></li>
                                        <!-- <li><a href="#">Analytical Reports</a></li> -->
                                        <!-- <li><a href="#">Engineering Resources</a></li> -->
                                        <li><a routerLink="/industry-news" (click)="toToggleClass()">Industry News</a></li>
                                        <!-- <li><a href="#">Webinars</a></li> -->
                                        <!-- <li><a routerLink="/case-studies">Case Studies</a></li> -->
                                        <li><a routerLink="/community" (click)="toToggleClass()">Community</a></li>
                                        <li><a routerLink="/ebrochure" (click)="toToggleClass()">E-Brochure</a></li>
                                    </ul>
                                </li>
                                <li><a href="">Company</a>
                                    <ul>
                                        <li><a routerLink="/about-us" (click)="toToggleClass()">About Us</a></li>
                                        <li><a routerLink="/leadership-team" (click)="toToggleClass()">Leadership Team</a>
                                        </li>
                                        <li><a routerLink="/customers" (click)="toToggleClass()">Customers</a></li>
                                        <li><a routerLink="/partners" (click)="toToggleClass()">Partners</a></li>
                                        <li><a routerLink="/media" (click)="toToggleClass()">Media</a></li>
                                        <!-- <li><a href="#">Media center</a></li> -->
                                        <!-- <li><a routerLink="/leadership-team">Leadership Team</a></li> -->
                                        <li><a routerLink="/careers" (click)="toToggleClass()">Careers</a></li>
                                        <!-- <li><a routerLink="/life-at-protectt-ai" (click)="toToggleClass()">Life at
                                            Protectt.ai</a></li> -->
                                    </ul>
                                </li>
                        </ul>
                    </div>

                    <!-- <div class="mobile-more-info">
                <p>Have any question ? +215 2145 2154</p>
                <ul class="socail-top">
                    <li><a href="#"><i class="zmdi zmdi-facebook"></i></a></li>
                    <li><a href="#"><i class="zmdi zmdi-twitter"></i></a></li>
                    <li><a href="#"><i class="zmdi zmdi-vimeo"></i></a></li>
                    <li><a href="#"><i class="zmdi zmdi-linkedin"></i></a></li>
                </ul>
            </div>

            <div class="header-btn text-center">
                <a class="btn-circle btn-transparent btn" href="#">Appointment</a>
            </div> -->

                </div>
                <!-- Show in small device End -->
            </div>
        </div>
    </div>
</header>